// ABOUTME: Build-time frontend feature switches with safe defaults for non-phase-2 deployments.
// ABOUTME: Keeps shared phase-2 UI restrictions isolated from dev and production builds.

export function isDataSourcesEnabled(): boolean {
  return import.meta.env.VITE_DATA_SOURCES_ENABLED !== 'false';
}
